// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"Toggle_toggleContainer__bhJ83","floatingBox":"Toggle_floatingBox__S1J9B","icon":"Toggle_icon__UciGl","active":"Toggle_active__XfCEc"};